import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageGuardService } from './core/auth-guards/landing-page-guard.service';
import { LoggedInGuardService, LoggedInAgentGuardService } from './core/auth-guards/logged-in-guard.service';
import { AppComponent } from './app.component';

const routes: Routes = [
	{
		path: '',
		component: AppComponent,
		canActivate: [ LandingPageGuardService ],
		pathMatch: 'full'
	}, 
    {
        path: 'Public',
        children: [
            {
                path: 'Index',
                redirectTo: '/public',
                pathMatch: 'full',
            },
        ],
    },
	{
		path: 'public',
		loadChildren: () => import('../app/public-portal/public-portal.module').then((m) => m.PublicPortalModule)
	},
	{
		path: 'clerk',
		loadChildren: () =>
			import('../app/clerk-portal/clerk-search/clerk-search.module').then((m) => m.ClerkSearchModule),
		//'src/app/clerk-portal/clerk-search/clerk-search.module#ClerkSearchModule',
		canActivate: [ LoggedInGuardService ],
		pathMatch: 'full'
	},
	{
		path: 'agent',
		loadChildren: () =>
			import('../app/agent-portal/dashboard/dashboard.module').then((m) => m.DashboardModule),
		canActivate: [ LoggedInAgentGuardService ],
		pathMatch: 'full'
	},
	{
		path: 'mliRecordV2/:id',
		loadChildren: () =>
			import('../app/clerk-portal/mli-record-v2/mli-record-v2.module').then((m) => m.MliRecordV2Module),
		canActivate: [ LoggedInGuardService ],
		pathMatch: 'full'
	},
	{
		path: 'detail/:id',
		loadChildren: () =>
			import('../app/agent-portal/detail/detail.module').then((m) => m.DetailModule),
		canActivate: [ LoggedInAgentGuardService ],
		pathMatch: 'full'
	},
	{
		path: 'error',
		loadChildren: () => import('../app/core/error-pages/error-pages.module').then((m) => m.ErrorPagesModule)
		//'src/app/core/error-pages/error-pages.module#ErrorPagesModule'
    }
	// {
	// 	path: 'guide',
	// 	loadChildren: () => import('../app/shared/components/guide/guide.module').then((m) => m.GuideModule)
	// }
];

@NgModule({
	imports: [ RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }) ],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}
